var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingCircle = function SvgLoadingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7A6.5 6.5 0 1 0 7 13.5M9 13.187a6.5 6.5 0 0 0 1.793-.907M13.187 9a6.5 6.5 0 0 1-.907 1.792"
  }))));
};
export default SvgLoadingCircle;